

<template>
  <main id="app">
  <div  class="is-full is-flex is-justify-content-center header">
    
    <div class="is-flex is-justify-content-center">
    <h1>YUP <span class="memoryIcon"><MemoryIcon/></span>  STATUS</h1>
    </div>
    

     <div v-if="firstCheck" class="is-flex is-justify-content-center is-flex-direction-column">
      <h2 class="is-flex is-justify-content-center ">Last Check:</h2>
      <div ref="lastCheckEl" :key="lastCheckId" class="check head-check is-flex is-justify-content-center" :class="{ 'fade-in':checkAnim }">
      <span  class="data signal" :class="{ 'offline':!firstCheck.status }">{{firstCheck.status ? 'ONLINE' : 'OFFLINE'}}</span>
      <span> <span class="is-hidden-mobile">Check Date:</span> {{ moment.utc(firstCheck["check-date"]).local().format('MMMM Do YYYY, h:mm:ss a') }} </span>
      <span class="is-hidden-mobile"> Check By: {{ firstCheck.checker === '0' ? 'node-server': check.checker}}</span>
      </div>
     </div>

    <div class="is-flex is-justify-content-center is-flex-direction-column">
      <h2 class="fade-in is-flex is-justify-content-center">No. Checks made: <span class="green">&nbsp;{{ totalChecksDone }}&nbsp;</span> | 
       No. Checks purged: <span class="red">&nbsp;{{ totalChecksDel }}&nbsp;</span></h2>
      <h2 class="is-flex is-justify-content-center">Next Check:</h2>
      <div ref="checkpel" class="check-progress is-flex is-justify-content-center"></div>
      <h2 class="fade-in is-flex is-justify-content-center">No. Checks Up: <span class="green">&nbsp;{{ totatChecksUp }}&nbsp;</span> | 
       No. Checks Down: <span class="red">&nbsp;{{ totatChecksDown }}&nbsp;</span></h2>
       <h2  class="is-flex is-justify-content-center" >Uptime: {{ uptime }}%</h2>

    </div>

  </div>


  <div class="columns" style="border-top: 1px solid #555;">
  <div style="background-color: rgb(16, 16, 16 / 71%); border-right: 1px solid #555;" class="column">

        <div style="text-align: center;color: steelblue;" v-if="time" class="clock-digital">{{time}}</div>
 
        <table :key="tablekey" v-if="checks" class="status-dot-table">
            <tr v-for="j in 7" :key="j" class='dot'>
            <b-tooltip
            v-for="n in 10" :key="checks[n+j].id" 
            :label="moment.utc(checks[n+j]['check-date']).local().format('MMMM Do YYYY, h:mm:ss a')"
            position="is-top"
            size="is-medium"
            :type="checkStatus(n+j)? 'is-success':'is-warning'"
            multilined>
                <td class="fade-in" :class="{ 'online':checkStatus(n+j), 'offline':!checkStatus(n+j) }" ></td>
                 </b-tooltip>
            </tr>
        </table>


    <div v-if="lastCheckDown" class="is-flex is-justify-content-center is-flex-direction-column">
    <div style="color:#f2f2f2; max-width:25rem; margin-right:auto; margin-left:auto;margin-top:1.2rem;" class="check is-flex is-justify-content-center is-flex-direction-column">
       <h2 style="font-width:bold;"><b>Last Offline Check:</b></h2>
       <p><b>Date: </b></p>
       <p>{{lastCheckDown.date}}</p>
       <p><b>Type: </b><span :class="{ 'partial':lastCheckDown.accounts.ramOverUsedForYupManager || lastCheckDown.accounts.ramOverUsedForYupProtocol, 'offline':lastCheckDown.accounts.ramOverUsedForYupManager && lastCheckDown.accounts.ramOverUsedForYupProtocol }">{{ lastCheckDown.accounts.ramOverUsedForYupManager && lastCheckDown.accounts.ramOverUsedForYupProtocol ? 'TOTAL' : 'PARTIAL' }}</span></p>
       <p><b>YupProtocol</b></p>
       <p style="position:relative;"><b><MemoryIcon class="lastofflineIcon"/> OverUse: </b><span :class="{ 'online':!lastCheckDown.accounts.ramOverUsedForYupProtocol , 'offline':lastCheckDown.accounts.ramOverUsedForYupProtocol }" >{{lastCheckDown.accounts.ramOverUsedForYupProtocol.toString()}}</span></p>
       <p><b>YupAccManager</b></p>
       <p style="position:relative;" ><b><MemoryIcon  class="lastofflineIcon"/> OverUse: </b><span :class="{ 'online':!lastCheckDown.accounts.ramOverUsedForYupManager , 'offline':lastCheckDown.accounts.ramOverUsedForYupManager }">{{ lastCheckDown.accounts.ramOverUsedForYupManager.toString() }}</span></p>
       </div>
 
     </div>
    
      

     <div v-if="LastCuratorRwdTime" class="is-flex is-justify-content-center is-flex-direction-column">
     <div style="color:#f2f2f2; max-width:25rem; margin-right:auto; margin-left:auto;margin-top:1.2rem;" class="check is-flex is-justify-content-center is-flex-direction-column">
       <p><b>Last Curator reward:</b></p>
       <p>{{ LastCuratorRwdTime }}</p>
       </div>
 
     </div>

<b-button style="margin-left: auto;margin-right: auto; margin-top: 1rem;" class="is-flex is-justify-content-center" :loading="btnCLCURTLoading" :disabled="btnCLCURTDisabled" @click="checkLastCuratorRwdTime" type="is-warning">
{{ btnCLCURTLoading ?  '' : btnCLCURTDisabled ? local.btnCULURTTextDisabled  + btnCLCURTRecheckTime + ' s'  : local.btnCULURTText }}
</b-button>


     <div v-if="lastBridgeTransfers" class="is-flex is-justify-content-center is-flex-direction-column">
     <div v-for="transfer in lastBridgeTransfers" :key="transfer.from" style="color:#f2f2f2; max-width:25rem; margin-right:auto; margin-left:auto;margin-top:1.2rem;" class="check is-flex is-justify-content-center is-flex-direction-column">
       <p><b>User: </b>{{ transfer.from }}</p>
       <p><b>Amount: </b>{{ transfer.amount }}</p>
       <p><b>Eth: </b></p>
       <p>{{ transfer.eth }}</p>
       <p><b>Date:</b></p>
       <p>{{ transfer.date }}</p>
       </div>
     </div>
 
<b-button v-html="btnBriTrLoading ?  '' : btnBriTrDisabled ? local.btnBriTransTextDisabled  + btnBriTrRecheckTime + ' s'  : local.btnBriTransText " style="margin-left: auto;margin-right: auto; margin-top: 1rem;" class="is-flex is-justify-content-center" :loading="btnBriTrLoading" :disabled="btnBriTrDisabled" @click="checkLastTenBridgeTransfers" type="is-warning">
</b-button>


  </div>
  <div class="column is-three-quarters content-main">
    <ul :class="{ 'blink':listLoading }" :key="checkListid" v-if="checks">
      <li v-for="check in checkList" v-bind:key="check.id">
      <div class="check content-check fade-in">
      <span class="data signal" :class="{ 'offline':!check.status }">{{check.status ? 'ONLINE' : 'OFFLINE'}}</span>
      <span> <span class="is-hidden-mobile">Check Date:</span> {{ moment.utc(check["check-date"]).local().format('MMMM Do YYYY, h:mm:ss a') }} </span>
      <span class="is-hidden-mobile"> Check By: {{ check.checker === '0' ? 'node-server': check.checker}}</span>
      </div>
      </li>
    </ul>

        <hr style="max-width:70rem;opacity:0.7">
        <b-pagination
            style="margin:1.5rem"
            :total="total"
            v-model="current"
            :range-before="rangeBefore"
            :range-after="rangeAfter"
            :order="order"
            :size="size"
            :simple="isSimple"
            :rounded="isRounded"
            :per-page="perPage"
            @change="changePage"
            ref="elpagination"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">



            <template #previous="props">
                <b-pagination-button
                    :page="props.page">
                     <ChevronLeftIcon /> Previous
                </b-pagination-button>
            </template>

            <template #next="props">
                <b-pagination-button
                    :page="props.page">
                    Next <ChevronRightIcon />
                </b-pagination-button>
            </template>
            
        </b-pagination>
        <hr style="max-width:70rem;opacity:0.7">

        <small>Made By <a href="https://blog.flashsoft.eu">andrei0x309</a></small>
  </div>
  </div>
 
  
  </main>
</template>

<script>
 import { createClient } from '@supabase/supabase-js'
 import moment from 'moment';
 import CircleProgress from './circleP.js';
 import Memory from 'vue-material-design-icons/Memory.vue';
 import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue';
 import ChevronRight from 'vue-material-design-icons/ChevronRight.vue';
 

 const publicToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYyODgxOTYyOCwiZXhwIjoxOTQ0Mzk1NjI4fQ.KtH5mT2Ab7D5my6LQhidAjnoE0ShlU3h5b8m_ohmbpw";
 const supabase = createClient("https://lcspcmmpolegvalxkfsu.supabase.co", publicToken)
 

export default {
  name: 'App',
  components: {
    MemoryIcon: Memory,
     /* eslint-disable-next-line */
    ChevronLeftIcon: ChevronLeft,
    /* eslint-disable-next-line */
    ChevronRightIcon: ChevronRight
  },
  data () {
    return {
      checkDisabledFor:0,
      checks: null,
      totalChecksDone: 0,
      totatChecksUp: 0,
      totatChecksDown: 0,
      totalChecksDel: 0,
      isFullPage: true,
      moment: moment,
      circleP: null,
      rSeconds: 79,
      lastCheckId: 0,
      checkListid: 0,
      checkAnim: false,
      time: null,
      tablekey: 0,
      lastCheckDown: null,

                // Pagination
                listLoading: false,
                total: 2000,
                current: 1,
                perPage: 70,
                rangeBefore: 2,
                rangeAfter: 2,
                order: 'is-centered',
                size: '',
                isSimple: false,
                isRounded: true,

      // Check Curator Pay Btn 
      LastCuratorRwdTime: false,
      btnCLCURTLoading: false,
      btnCLCURTDisabled: false,
      btnCLCURTRecheckTime: 0,
       // Check Curator Pay Btn 
      lastBridgeTransfers: null,
      btnBriTrLoading: false,
      btnBriTrDisabled: false,
      btnBriTrRecheckTime: 0,
      
    }
  },
  async mounted () {
   const loadingComponent = this.$buefy.loading.open();
 
   this.checks = (await supabase.from('uptime-check-record').select('*').order('check-date', { ascending: false }).limit(70)).data;
   const settings  = await supabase.from('yup-status-settings').select().order('id', { ascending: true });
   
   this.totatChecksUp = Number(settings.data[0].value);
   this.totatChecksDown = Number(settings.data[2].value);
   this.totalChecksDone  = Number(this.totatChecksUp) + Number(this.totatChecksDown);
   const lastCheckDown = settings.data[3];
   if(lastCheckDown.value){
     const lastCheckDownItem = {};
     lastCheckDownItem.date =   moment.utc(Number(lastCheckDown.value)).local().format('MMMM Do YYYY, h:mm:ss a');
     lastCheckDownItem.accounts = lastCheckDown['json-value'];
     this.lastCheckDown = lastCheckDownItem;
     console.log(this.lastCheckDown);
   }

   this.totalChecksDel = settings.data[1].value;


   const mRsec = 75 - moment.utc(Date.now()).subtract( moment.utc(this.checks[0]["check-date"] )).unix();
   this.rSeconds = mRsec  >= 79 ? 79 : mRsec+5;

   this.circleP = new CircleProgress(this.$refs.checkpel, { max:79, value:this.rSeconds, textFormat: function(value) {
		return value + ' seconds'
	} })
  this.getTime();
    setTimeout(() => { console.log(1), this.updateProgess()}, 1000);


   loadingComponent.close();
 
  },
  computed: {
  firstCheck () {
    if(this.checks) return this.checks[0];
    return null;
  },
  checkList () {
     if(this.checks) return this.checks.slice(1,69);
     return null;
  },
  uptime() {
     if(this.totatChecksUp >  this.totatChecksDown) {
      return  ((this.totatChecksUp - this.totatChecksDown) / this.totatChecksUp * 100).toFixed(6);
 
    }else{
      return  ((this.totatChecksDown - this.totatChecksUp) / this.totatChecksDown * 100).toFixed(6);
    }
  }
  
  },
  methods: {
    checkLastCuratorRwdTime: async function () {
      try {
      this.btnCLCURTLoading = true;
      this.btnCLCURTDisabled = true;
      const timeStamp = 
     (await(await fetch('https://eos.hyperion.eosrio.io/v2/history/get_actions?account=yupyupyupyup&filter=*%3Aclaimcurwds&skip=0&limit=1&sort=desc')).json()).timestamp;
     this.LastCuratorRwdTime = moment.utc(timeStamp).local().format('MMMM Do YYYY, h:mm:ss a');
     this.btnCLCURTRecheckTime = 30;
     this.btnCLCURTLoading = false;
     } catch {
             this.btnCLCURTLoading = false;
             this.btnCLCURTDisabled = false;
             this.btnCLCURTRecheckTime = 0;

                this.$buefy.snackbar.open({
                    duration:7500,
                    message: 'Check could not be done, HYPERION API may be down!',
                    position:'is-top',
                    type:'is-warning'
                });
     }

    },
    checkLastTenBridgeTransfers: async function () {
  try {
      this.btnBriTrLoading = true;
      this.btnBriTrDisabled = true;
      const briTrasTempArr = [];
      const briTransFetchData = 
     (await(await fetch('https://eos.hyperion.eosrio.io/v2/history/get_actions?account=bridge.yup&filter=*%3Atransfer&skip=0&limit=35&sort=desc')).json()).actions;
      let count = 0;
      for (const tr of briTransFetchData) {
        if(tr.act.account === "token.yup"){
          const brTransItem = {};
          brTransItem.from = tr.act.data.from;
          brTransItem.eth = tr.act.data.memo;
          brTransItem.amount = tr.act.data.quantity.replace(/\.\d\d\d\d/g, '');
          brTransItem.date = moment.utc(tr.timestamp).local().format('MMMM Do YYYY, h:mm:ss a');
          briTrasTempArr.push(brTransItem);
          count++;
          console.log(brTransItem);
        }else continue;
        if(count >= 10) { 
          this.lastBridgeTransfers = briTrasTempArr;
          break;
        }
      }
     this.btnBriTrRecheckTime = 30;
     this.btnBriTrLoading = false;
     } catch {
             this.btnBriTrLoading = false;
             this.btnBriTrDisabled = false;
             this.btnBriTrRecheckTime = 0;

                this.$buefy.snackbar.open({
                    duration:7500,
                    message: 'Check could not be done, HYPERION API may be down!',
                    position:'is-top',
                    type:'is-warning'
                });
     }

    },
 
    submitCheck: function () {
    },
    changePage: async function (page) {
        console.log(page);
        this.listLoading = true;
        this.current = page;
        const skipNo = page -1;
        this.checks = (await supabase.from('uptime-check-record').select('*').order('check-date', { ascending: false }).range(70*skipNo,70*page)).data;
        this.listLoading = false;

    },
      checkStatus(n){
    if(this.checks) return this.checks[n].status;
    return null;
  },
    addZero(i){
            if (i < 10) {
                i = "0" + i;
            }
            return i;
    },
    getTime() {
           const d = new Date();
            const h = d.getHours();
            const m = d.getMinutes();
            const s = d.getSeconds();

            this.time= `${this.addZero(h)} : ${this.addZero(m)} : ${this.addZero(s)}`;

    },
    updateProgess: async function () {
      console.log(this.rSeconds);
      this.circleP.value = this.rSeconds--;
      if(this.rSeconds <= 0) {
        await this.loadNewCheck();
      }
      if (this.btnCLCURTRecheckTime > 0) {
        this.btnCLCURTRecheckTime--;
      }else{
        this.btnCLCURTDisabled = false;
      }
      if (this.btnBriTrRecheckTime > 0) {
        this.btnBriTrRecheckTime--;
      }else{
        this.btnBriTrDisabled = false;
      }
      this.getTime();

      setTimeout(() => { this.updateProgess() }, 995);
    },

    loadNewCheck: async function() {
        const lastCheck = (await supabase.from('uptime-check-record').select('*').order('check-date', { ascending: false }).limit(1)).data[0];
         console.log(lastCheck.id, this.checks[0].id);
        if(lastCheck.id !== this.checks[0].id) {
        this.checks = [lastCheck, ...this.checks.slice(0,69)];
        this.$nextTick(() => {
        this.checkAnim = true;
        setTimeout(() => { this.checkAnim = false }, 1000);
        });
        //this.totalChecksDone = (await supabase.from('yup-status-settings').select('*').eq( 'id', 1 )).data[0].value;
        this.totalChecksDone++;
        lastCheck.status ? this.totatChecksUp++ : this.totatChecksDown++;
         const mRsec = 75 - moment.utc(Date.now()).subtract( moment.utc(this.checks[0]["check-date"] )).unix(); 
        this.rSeconds = mRsec+5;
        this.tablekey = this.tablekey+1;
        }else{
          this.rSeconds = 79;
          console.log('no new check');
          this.errorNoNewCheck();
        }
        
    },
    errorNoNewCheck() {
                this.$buefy.snackbar.open({
                    duration:7500,
                    message: 'No new check!',
                    position:'is-top',
                    type:'is-warning'
                });
    },
  },
  watch: {
   
  },
  async beforeCreate () {

  },
  created () {
    this.local = {};
    this.local.btnCULURTText = 'Check last curator reward time';
    this.local.btnCULURTTextDisabled = 'You can recheck in: ';

    this.local.btnBriTransText = 'Check last&nbsp;&nbsp;<b>10</b>&nbsp;&nbsp;bridge transfers';
    this.local.btnBriTransTextDisabled = 'You can recheck in: ';
 
  },


}
</script>

<style lang="scss">
 
$cGood: #2eb35a;
$cAlert: #d22c32;
$orange: #ff6b23;
$blue: #54c6fb;

 html {
   background-color: #1f1f1f!important;
   color: #fff!important;
   min-width: 100%;
 }

body {
  position: relative;
  min-width: 100%;
}

 .header {
  margin-top: 8vh;
  margin-bottom: 2rem;
  flex-direction: column;

.head-check {
  max-width: 38rem;
    margin: 1rem auto;
    padding: 0.3rem;
    font-size: 0.9rem;
    color: antiquewhite;
}

h1 {
            font-weight: bold;
            font-size: 2.5rem;
            color: wheat;
    
    .memoryIcon{
    position: relative;
    color: lightblue;
    }

    .memoryIcon:before{
    display: inline-block;
    content: "";
    position: absolute;
    width: 0.75em;
    height: 0.75em;
    border: 1px solid #03a9f4;
    border-radius: 50%;
    top: 0.4em;
    left: -0.08em;
    }

}

h2 {
  font-size: 1.1rem;
  color: #fee;
  margin-top: 1rem;
  margin-left: -0.5rem;
  margin-bottom: 0.3rem;
}

span.green {
   color: $cGood;
}

span.red {
  color: $cAlert;
}

 }
 
 .circle-progress {
    width:11rem;
    height:auto;
 }

.circle-progress-value {
	stroke-width: 0.45rem;
	stroke: hsl(39, 100%, 50%);
}
.circle-progress-circle {
	stroke-width: 0.45rem;
	stroke: hsl(39, 100%, 85%);
}
.circle-progress-text {
	fill: hsl(39, 100%, 50%);
}

.content-main{
  background-color: rgb(33, 34, 62);
  color: aliceblue;
 
.content-check {
    max-width: 50rem;
    margin: 1rem 10%;
    padding: 0.3rem;
    font-size: 0.9rem;
    color: antiquewhite;
    padding-left: 5%;
}


}

.lastofflineIcon{
  position: absolute;
  top: -5px;
  left: -25px;
  color: #dfdfdf;
  opacity: 0.8;

  svg {
    width:1.1rem;
  }


}
 
        .signal {
            color: $cGood;
            &::before {
                content: '';
                display: inline-block;
                width: .6rem;
                height: .6rem;
                background-color: currentColor;
                border-radius: 50%;
                margin-right: .5rem;
                margin-top: -.2rem;
                vertical-align: middle;
            }
        }
       
       .fade-in {
         opacity: 1;
         animation: fadeIn .9s ease-in;
       }


        .check {
          display: flex;
          align-items: center;
          margin: 0.2rem;
          padding: 1rem;       
          border: 1px solid rgba(255, 255, 255, .1);
          border-radius: 4px;
          white-space: nowrap;
          background-color: rgba(255, 255, 255, .1);

        .offline {
          color: $cAlert;

        }

          .online {
                 color: $cGood;
            }

            .partial {
                color:  $orange;
            }

        span{
          padding: 0.4rem;
        }
        span.signal {
          padding-right: 1rem;
        }

        }

@keyframes fadeIn {
  0% {opacity:0;}
  100% {opacity:1;}
}

.clock {
        display: flex;
        align-items: center;
    
        &-digital {
            font-weight: bold;
            font-size: 2.5rem;
        }
 }

.status-dot-table{
           margin: auto;
            border-collapse:separate;
          
            
            td {
                height: .6rem;
    width: .6rem;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: inline-block;
    padding: .6rem;
    margin: 0.2rem;
            }
        
            .online {
                background-color: $cGood;
            }

            .offline {
                background-color: $cAlert;
            }
            
            .partial {
                background-color: $orange;
            }

}

.blink {
  animation: blinker 1.3s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.pagination {

max-width: 65rem;

.pagination-previous:disabled {
  color: black;
  opacity: 0.4;
}

.pagination-link {
      color: white;
}

.pagination-link.is-current {

background-color: #7957d5;
    border-color: #7957d5;
    color: #fff;
}

.chevron-left-icon, .chevron-right-icon {
  margin-top: 0.5rem;
}

}


</style>
